import request from '@/utils/request' //引入封装好的 axios 请求

export function deleteNews(newsIds) {
  return request({
    url: '/news/deleteNews',
    method: 'post',
    contentType: "application/json;charset=UTF-8",
    data:newsIds
  })
}